import xs from 'xstream';
import * as ActionTypes from '../actions/index';
import BASE_URL from './variables';
import { failedGetSingleStagedPremium, getSingleStagedPremium, receiveSingleStagedPremium } from '../reducers/stagedPremiumsWizard';
import { failedGetAllStagedPremium, failedGetCurrentStagedPremium, getAllStagedPremium, getCurrentStagedPremium, receiveAllStagedPremium, receiveCurrentStagedPremium, resetDisplayedStagedPremiumSetting } from '../reducers/stagedPremiums';
export function requestStagedPremiumSetting(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === getCurrentStagedPremium.type)
		.map(action => ({
			url: BASE_URL + 'api/PremiumSettings/Staged/Current?caseType=' + action.payload.caseTypeId + 
			'&subCaseType=' +
				action.payload.subCaseTypeId + '&solicitorGroup=' + action.payload.solicitorGroupId + '&workSource=' + action.payload.workSourceId,
			category: 'getStagedPremium',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveCurrentStagedPremium(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestStagedPremiumSetting(sources) {
	let httpResponse$ = sources.HTTP
		.select('getStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => failedGetCurrentStagedPremium(response));

	return {
		ACTION: httpResponse$
	};
}

export function requestAllStagedPremiumSettings(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === getAllStagedPremium.type)
		.map(action => ({
			url: BASE_URL + 'api/PremiumSettings/Staged?caseType=' + action.payload.caseTypeId + 
			'&subCaseType=' + action.payload.subCaseTypeId + '&solicitorGroup=' + action.payload.solicitorGroupId + '&workSource=' + action.payload.workSourceId,
			category: 'getAllStagedPremiums',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getAllStagedPremiums')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveAllStagedPremium(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestAllStagedPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('getAllStagedPremiums')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => failedGetAllStagedPremium(response));

	return {
		ACTION: httpResponse$
	};
}


export function requestSingleStagedPremiumSettings(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === getSingleStagedPremium.type)
		.map(action => ({
			url: BASE_URL + 'api/PremiumSettings/Settings/' + action.payload,
			category: 'getSingleStagedPremium',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getSingleStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveSingleStagedPremium(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestSingleStagedPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSingleStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => failedGetSingleStagedPremium(response));

	return {
		ACTION: httpResponse$
	};
}

export function resetDisplayedSetting(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.CHANGE_NEW_PREMIUM_STORE_SETTINGS )
		.filter(action => action.payload)
		.filter(action => action.payload.key)
		.filter(action => action.payload.key == 'selectedSubCaseType')
		.map(action => resetDisplayedStagedPremiumSetting());
	return {
		ACTION: request$,
	};
}